

import * as React from "react";
import { Box,  } from "@mui/material";

const Footer = () => {
  return (
    <>
      <Box
        className="footer-area"
        sx={{
          textAlign: "center",
          bgcolor: "#fff",
          borderRadius: "7px 7px 0 0",
          padding: "20px 25px",
        }}
      >
        {/* <Typography>
          © <span className="text-purple"></span>{" "}
          <a
            href="https://www.DevforHealth.com/"
            target="_blank"
            rel="noreferrer"
            className="text-primary"
            style={{
              textDecoration: "none",
            }}
          >
            Dev For Health
          </a>
        </Typography> */}
      </Box>
    </>
  );
};

export default Footer;
